import { render } from "./AccountAddress.vue?vue&type=template&id=9f245e56"
import script from "./AccountAddress.vue?vue&type=script&lang=js"
export * from "./AccountAddress.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macmini/Sites/self-ship/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__